import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  DASHBOARD,
  DASHBOARD_MEMBER,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'dashboard' })
export default class Dashboard extends VuexModule {
  dashboard: any = {};

  dashboardMember: any = {};

  dashboardNewDownline: any = {};

  @Mutation
  mutateDashboard(dashboard) {
    this.dashboard = dashboard;
  }

  @Action({ commit: 'mutateDashboard' })
  FetchDashboard(params) {
    return Vue.axios({
      url: BASE_URL + DASHBOARD,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const dashboard = data.data;
          return dashboard;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateDashboardMember(dashboardMember) {
    this.dashboardMember = dashboardMember;
  }

  @Action({ commit: 'mutateDashboardMember' })
  FetchDashboardMember() {
    return Vue.axios({
      url: BASE_URL + DASHBOARD_MEMBER,
      method: M_POST,
      data: {},
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const dashboardMember = data.data;
          return dashboardMember;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
